<template>
  <a-result status="404" title="404" subTitle="抱歉，您访问的页面不存在！">
  </a-result>
</template>

<script>
export default {
  name: '404',
  components: {},
  data () {
    return {}
  },
  computed: {},
  methods: {}
}
</script>

<style>
</style>
